import React from 'react';
import PropTypes from 'prop-types';

const EnterFullscreenPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M20.5 4a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5H25a1 1 0 0 1 1 1v4.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-8A1.5 1.5 0 0 0 28.5 4h-8zm-17 0A1.5 1.5 0 0 0 2 5.5v8a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V9a1 1 0 0 1 1-1h4.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-8zm23 14a.5.5 0 0 0-.5.5V23a1 1 0 0 1-1 1h-4.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h8a1.5 1.5 0 0 0 1.5-1.5v-8a.5.5 0 0 0-.5-.5h-3zm-24 0a.5.5 0 0 0-.5.5v8A1.5 1.5 0 0 0 3.5 28h8a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5H7a1 1 0 0 1-1-1v-4.5a.5.5 0 0 0-.5-.5h-3z"
    />
  );
};

EnterFullscreenPath.propTypes = {
  fill: PropTypes.string,
};

export default EnterFullscreenPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/enter-fullscreen.jsx